module.exports = __webpack_public_path__ + "static/media/Curbside.4e125016.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/iLocal-Delivery-Icons/Curbside.svg
// module id = 1044
// module chunks = 0